import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "@env/environment";
import {catchError, retry} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class SprintService {

    apiURL = environment.apiURL;

    constructor(private http: HttpClient) {
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
    
            return of(result as T);
        };
    }

    getSprintData(id) {
        let params = new HttpParams().set('id', id);
        return this.http.get(this.apiURL + '/boards/getSprint', {params: params})
            .pipe(retry(1),
                catchError(this.handleError('getSprintData')));
    }

    saveSprintData(mode, data) {
        let params = new HttpParams()
            .set('mode', mode)
            .set('data', JSON.stringify(data));

        return this.http.post(this.apiURL + '/boards/saveSprint', params)
            .pipe(retry(1),
                catchError(this.handleError('saveSprintData')))

    }

    deleteSprint(sprintId) {

        let params = new HttpParams().set('id', sprintId);
        return this.http.post(this.apiURL + '/boards/deleteSprint', params)
            .pipe(retry(1),
                catchError(this.handleError('deleteSprint')));


    }

    // funkcija za uzimanje aktivnih sprintova po projektu

    getScrumBoard(projectId) {
        const params = new HttpParams().set('project_id', projectId);
        return this.http.get(this.apiURL + '/boards/getScrumBoard', {params: params}).pipe(retry(1),
            catchError(this.handleError('getScrumBoard')));
    }
}
